import {
	START_FETCH_ME,
	FETCH_ME_SUCCESS,
	FETCH_ME_FAILED,

	START_HEARTBEAT,
	STOP_HEARTBEAT,
} from './action-types';

export function fetchMeAction() {
	return {
		type: START_FETCH_ME,
	};
}

export function fetchMeSuccessAction(me) {
	return {
		type: FETCH_ME_SUCCESS,
		me,
	};
}

export function fetchMeFailedAction(error, errorMessage) {
	return {
		type: FETCH_ME_FAILED,
		error,
		errorMessage,
	};
}

export function startHeartbeatAction() {
	return {
		type: START_HEARTBEAT,
	};
}

export function stopHeartbeatAction() {
	return {
		type: STOP_HEARTBEAT,
	};
}
